export const lang = {
    message: {
        loginTitle: '温控系统后台管理平台',
        loginUser: '请输入用户名',
        loginPassword: '请输入密码',
        loginBtn: '登录',
        homeTitle: '温控系统后台管理平台',
        logout: '退出',
        exit: '账号退出成功！',
        loginSuccess: '登录成功！',
        loginFailed: '账号或密码错误，请重新登录！',

        menuUser: '用户管理',
        menuDev: '设备管理',
        userTitle: '用户管理',
        userNumber: '序号',
        userName: '用户名',
        userAccount: '账号',
        userDevicesNum: '设备数',
        userEmail: '邮箱',
        userOpeateModify: '修改',
        userOpeateDelete: '删除',
        userViewBindDev: '设备绑定',
        userDialogModifyTitle: '修改',
        userDialogModifyUserName: '用户名',
        userDialogModifyPassWord: '密码',
        userNamePlaceHolder: '请输入用户名',
        userEmailPlaceHolder: '请输入邮箱',
        userAccountPlaceHolder: '请输入账号',

        opeate: '操作',
        opeateView: '查看',

        devTitle: '设备管理',
        devName: '设备名',
        devMacAddr: 'Mac地址',
        devDetails: '设备详情',
        devID: '设备ID',
        devMAC: '设备MAC地址',
        devNames: '设备名',
        devIdPlaceHolder: '请输入设备ID',
        devMACPlaceHolder: '请输入设备MAC地址',
        devNamePlaceHolder: '请输入设备名称',

        btnYes: '确定',
        btnNo: '取消',

        boxTitle: '提示',
        boxTips: '此操作将永久删除该数据, 是否继续?',
        boxDelCancel: '已取消删除',
        boxDelSuccess: '删除成功',
        boxModifySuccess: '修改成功',
        boxModifyFailed: '修改失败',
        boxModifyFailedMsg: '请填写用户名或密码',
        boxModifypswErr: '密码只能由字母和数字组成',
        boxModifypswLength: '密码长度应在6至16位',
        boxModifynameLength: '用户名长度应在1至16位',

        pagePre: '上一页',
        pageNext: '下一页',

        tableNoData: '暂无数据',

        formUserTitle: {
            kaiguan: "开机状态",
            shouzi: "模式",
            jianpan: "按键锁定",
            famen1: "阀门1状态",
            fangdong: "防冻开标志",
            override: "override",
            wendushow: "当前温度格式",
            week: '星期'
        },
        wendu: '当前温度',
        setwendu: "设定温度",
        time: "设备时间",
        userState: {
            kaiguan: {
                0: '关机',
                1: '开机'
            },
            shouzi: {
                0: '自动',
                1: "手动"
            },
            jianpan: {
                0: '未锁定',
                1: '锁定'
            },
            famen1: {
                0: '关',
                1: '开'
            },
            fangdong: {
                0: '关',
                1: '开'
            },
            override: {
                0: '无',
                1: '有'
            },
            wendushow: {
                0: '℃',
                1: '℉'
            },
            week: {
                0: '周日',
                1: '周一',
                2: '周二',
                3: '周三',
                4: '周四',
                5: '周五',
                6: '周六'
            }
        },
        formDevTitle: {
            cewen: ' 测温工作模式',
            cewenshow: ' 当前显示温度',
            timeshow: '时间模式',
            biancheng: '编程模式',
            waiwenchuangan: '外部温度传感器型号',

            kaiguan: "开机状态",
            shouzi: "模式",
            jianpan: "按键锁定",
            famen1: "阀门1状态",
            fangdong: "防冻开标志",
            overide: "override",
            wendushow: "当前温度格式",
            week: '星期'
        },

        huicha: '控制温度回差',
        neijiao: '房间温度校准',
        waijiao: '外部温度校准',
        waiwenshang: '外部限定温度最大值',
        wensia: '房间最小设定温度',
        wenshang: '房间最大设定温度',
        beiguang: '无按键输入背光关闭时间',
        devState: {
            cewen: {
                0: 'A',
                1: 'AF',
                2: 'F'
            },
            cewenshow: {
                0: 'A',
                1: 'AF',
                2: 'F'
            },
            timeshow: {
                0: '24h',
                1: '12h',
            },
            biancheng: {
                0: '5+2',
                1: '7day',
            },
            waiwenchuangan: {
                0: '3K',
                1: '15k',
                2: '10k',
                3: '100k'
            },
            kaiguan: {
                0: '关机',
                1: '开机'
            },
            shouzi: {
                0: '自动',
                1: "手动"
            },
            jianpan: {
                0: '未锁定',
                1: '锁定'
            },
            famen1: {
                0: '关',
                1: '开'
            },
            fangdong: {
                0: '关',
                1: '开'
            },
            overide: {
                0: '无',
                1: '有'
            },
            wendushow: {
                0: '℃',
                1: '℉'
            },
            week: {
                0: '周日',
                1: '周一',
                2: '周二',
                3: '周三',
                4: '周四',
                5: '周五',
                6: '周六'
            }
        }
    }
}